import React from 'react';
import { GiftColored, CashColored } from '@teko/ds-icon';
import { styled, Body } from '@teko/ds-desktop';
import { t } from '../../i18n.es.js';

const Item = styled.div(({ hasBorder }) => `
  display: flex;
  margin-top: 7px;
  align-items: center;
  ${hasBorder ? " border-bottom: 1px dashed #e0e0e0; padding-bottom: 16px;" : ""}
`);
const Name = styled(Body)`
  flex: 1;
  align-item: center;
  margin-left: 2px;
`;
const Quantity = styled.span`
  color: #848788;
`;
const Applied = styled.span`
  font-size: 0.625rem;
  line-height: 1rem;
  color: #848788;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  text-transform: uppercase;
  padding: 3px;
  padding-bottom: 1px;
  margin-right: 5px;
`;
const PromotionItem = ({
  item = { quantity: 1, name: "", sku: "" },
  type,
  name,
  hasBorder,
  className
}) => {
  return /* @__PURE__ */ React.createElement(Item, {
    className,
    hasBorder
  }, type === "product" || type === "voucher" ? /* @__PURE__ */ React.createElement(GiftColored, null) : /* @__PURE__ */ React.createElement(CashColored, null), /* @__PURE__ */ React.createElement(Name, {
    lineHeight: 20
  }, type === "product" ? /* @__PURE__ */ React.createElement(Quantity, null, item.quantity, "x ") : /* @__PURE__ */ React.createElement(Applied, null, t("\u0110\xE3 \xE1p d\u1EE5ng")), /* @__PURE__ */ React.createElement("span", null, name || item.name)));
};

export { PromotionItem, PromotionItem as default };
